var i = 0;
function timedCount() {
    i = i + 1;
    postMessage(i, null, null);
    setTimeout("timedCount()", 5000);
}
function loadData() {
    var data = [
        {
            value: 300,
            color: "#F7464A",
            highlight: "#FF5A5E",
            label: "Red"
        },
        {
            value: 50,
            color: "#46BFBD",
            highlight: "#5AD3D1",
            label: "Green"
        },
        {
            value: 100,
            color: "#FDB45C",
            highlight: "#FFC870",
            label: "Yellow"
        }
    ];
    postMessage(data, null, null);
}
function initialize() {
    self.onmessage = function (e) {
        var data = e.data;
        switch (data) {
            case "loadData":
                setTimeout("loadData()", 2500);
                break;
        }
    };
}
initialize();

define("areas/home/workers/sampleworker", function(){});

